import {eventChannel} from 'redux-saga';
import {exportEvent, invalidateDataEvent, recognitionLimitExceedEvent, toggleDefaultTemplateDialogEvent} from '../constants';

export const createChannel = (client) => {
    if (!client) {
        return null;
    }

    const subscribe = (emitter) => {
        client.on(invalidateDataEvent, emitter);
        client.on(exportEvent, emitter);
        client.on(recognitionLimitExceedEvent, emitter);
        client.on(toggleDefaultTemplateDialogEvent, emitter);


        return () => {
            client.removeListener(invalidateDataEvent, emitter);
            client.removeListener(exportEvent, emitter);
            client.removeListener(recognitionLimitExceedEvent, emitter);
            client.removeListener(toggleDefaultTemplateDialogEvent, emitter);
        };
    };

    return eventChannel(subscribe);
};